import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { apiConfig } from '../../config'
import { getAccessToken, ApiScope } from '../silentAuth'
import { ObjectValueChangedNotification } from './types';
import EventEmitter from 'events';

export class ObjectsHubConnector extends EventEmitter {
  public connection: signalR.HubConnection;
  static instance: ObjectsHubConnector;
  constructor() {
    super();

    this.connection = new HubConnectionBuilder()
      .withUrl(apiConfig.objectsHubUrl, { accessTokenFactory: () => getAccessToken(ApiScope) })
      .withAutomaticReconnect()
      .configureLogging(LogLevel.Information)
      .build();

    this.connection.on('ValueChanged', (message: ObjectValueChangedNotification) => this.emit(message.objectId, message));
  }

  public static getInstance(): ObjectsHubConnector {
    if (!ObjectsHubConnector.instance)
      ObjectsHubConnector.instance = new ObjectsHubConnector();
    return ObjectsHubConnector.instance;
  }

}

